import i18n from './i18n';

const localizedPath = (path) => {
    const currentLanguage = i18n.language || 'en';
    const baseLangUrl = `/${currentLanguage}`;
    return baseLangUrl + path;
};

export default localizedPath;
